function TimeZoneOverrideProvider() {
    'ngInject';

    // This list of default options is meant to grow
    let isOverrideModeEnabled = false;

    this.unsafelyEnableOverrideMode = () => {
        isOverrideModeEnabled = true;
    };

    this.disableOverrideMode = () => {
        isOverrideModeEnabled = false;
    };

    this.isOverrideModeEnabled = () => {
        return isOverrideModeEnabled;
    };
}

/**
 * Please, never use this service
 */
angular
    .module('BB.i18n')
    .service('TimeZoneOverride', TimeZoneOverrideProvider);



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/-i18n/time-zone/time_zone_override.provider.js